import { createSelector } from '@reduxjs/toolkit';

import { BankAccountView } from 'models';

import { bankAccountsApi } from './api';

const emptyBankAccounts: BankAccountView[] = [];

const defaultBankAccountsSelector =
  bankAccountsApi.endpoints.getDefaultPortalBankAccountsList.select(
    'getDefaultPortalBankAccountsList'
  );

export const selectDefaultBankAccounts = createSelector(
  defaultBankAccountsSelector,
  (defaultBankAccountsResult) =>
    defaultBankAccountsResult?.data ?? emptyBankAccounts
);
